import React from "react";

const PlaceholderWeekRows = () => {
  const columns = 7;
  const rows = 6;

  const components: JSX.Element[] = [];

  for (let i = 0; i < rows; i++) {
    components.push(
      <div key={i} className="weekrow">
        <div>wk&nbsp;&nbsp;</div>
        {Array.from({ length: columns }, (_, i) => i).map((_, i) => (
          <div key={i} className="minicalendar_day minicalendar_day_0">
            &nbsp;
          </div>
        ))}
      </div>
    );
  }

  return <div>
    {components}
  </div>;
};

export default PlaceholderWeekRows;